(ns frontend.view.components.new-tags.view
  (:require
   [common.localization :as loc]
   [clojure.set :as set]
   [common.schema.registry :as registry]
   [reagent.core :as r]
   [potpuri.core :as p :refer [fn-> fn->> index-by]]
   [frontend.actions.entity :as entity-actions]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.logging :as logging]
   [common.util :as cu :refer [flip only-entity]]
   [common.entity :as entity]
   [common.attribute :as attribute]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.curtains.tag-curtain.view :as tag-curtain]
   [frontend.state.permissions :as f-permissions]
   [ui.components.button.view :as button]))


(defn remove-multi-opt
  [entity attribute value entity-atom]
  (let [old-value (get entity attribute)
        new-value (set/difference old-value #{(:db/id value)})]
    ;;optimistic save to frontend db:
    (logging/performance "remove tag")
    (swap! entity-atom assoc attribute new-value)
    (entity-actions/*->field-update!
     (:db/id entity)
     attribute
     new-value
     (fn [res]
     )
     (fn [err]
       ;;retract the optimistic save above
       (when (= new-value (get @entity-atom attribute))
         (swap! entity-atom assoc attribute old-value))
     ))))

(defn remove-single-opt
  [entity attribute value entity-atom]
  (let [old-value (get entity attribute)]
    ;;optimistic save to frontend db:
    (logging/performance "remove single tag")
    (swap! entity-atom dissoc attribute)
    (entity-actions/*->field-update!
     (:db/id entity)
     attribute
     nil
     (fn [res]
     )
     (fn [err]
       ;;retract the optimistic save above
       (when-not (get @entity-atom attribute)
         (swap! entity-atom assoc attribute old-value))
     ))))

(defn tag-element
  [{:keys [entity pipeline-id tag]}]
  (let [entity-atom (r/cursor session/entities [(:db/id entity)])]
    (fn [{:keys [entity pipeline-id tag]}]
      (let [[attribute value] tag
            field-schema (registry/get-field-schema @session/tenant-schema attribute)
            single-opt? (not= :data.type/ref-multi (:field/data-type field-schema))]
        [:div
         {:class-name "new-tag-container"}
         (entity/display-string value)
         (when (f-permissions/field-write-access? attribute (:entity/type entity) pipeline-id)
           [:div
            {:class "*:p-0"}
            [button/secondary-open 
             {:tooltip (loc/tr :remove-tag)}
             [:i.fas.fa-times-circle
              {:on-click (fn [_]
                           (if single-opt?
                             (remove-single-opt entity attribute value entity-atom)
                             (remove-multi-opt entity attribute value entity-atom)))}]]])]))))

(defn view
  [{:keys [entity-type entity-id asset-id edit-entity-id edit-entity-type icon title pipeline-id]
    :as   view-args}]
  (let [session-entities @session/entities
        tenant-schema @session/tenant-schema
        entity (get session-entities entity-id)
        attribute-schemas (->> (f-permissions/available-tag-attribute-schemas entity-type
                                                                              pipeline-id)
                               (sort-by (fn [a]
                                          (some->> a
                                                   (first)
                                                   (attribute/attribute-label tenant-schema)))))
        attributes (->> attribute-schemas
                        (map first))
        tags (->> attributes
                  (mapcat (fn [a]
                            (let [tags (get entity a)
                                  tag-ids (cond (nil? tags)
                                                nil
                                                (coll? tags)
                                                tags
                                                (number? tags)
                                                [tags])]
                              (->> tag-ids
                                   (map (fn [val]
                                          [a (get session-entities val)])))))))
        writable-tag-attributes
        (->> attribute-schemas
             (filter
              (fn [[attribute fs]]
                (f-permissions/field-write-access? attribute (:entity/type entity) pipeline-id))))]
    [:div.new-tags-container
     [:div
      {:class "flex items-baseline gap-2"}
      (when (or (seq writable-tag-attributes)
                (seq tags))
        [:i
         {:class-name (fu/cs "i fal new-tags-icon"
                             (or icon
                                 (entity/default-icon entity)))
          :on-click   (fn [_]
                        (when (seq writable-tag-attributes)
                          (modals/open-modal!
                           tag-curtain/modal-key
                           {:entity-id   edit-entity-id
                            :entity-type edit-entity-type
                            :header-text title
                            :pipeline-id pipeline-id
                            :asset-id    asset-id
                           })))}])
      [:div
       {:class-name (fu/cs "new-tag-container-wrapper"
                           (when (empty? tags)
                             "tags-empty"))}
       (doall
        (for [[index tag] (map-indexed vector tags)]
          ^{:key (str tag index)}
          [tag-element
           {:tag         tag
            :pipeline-id pipeline-id
            :entity      entity}]))]
      (when-not (empty? writable-tag-attributes)
        [button/square-secondary-hollow 
         {:tooltip (loc/tr :add-entity-tags [(loc/tr entity-type)])}
          [:i
          {:class-name (fu/cs "fal fa-plus"
                              "new-tags-open-editor-button")
           :on-click   (fn [_]
                         (modals/open-modal!
                          tag-curtain/modal-key
                          {:entity-id   edit-entity-id
                           :pipeline-id pipeline-id
                           :entity-type edit-entity-type
                           :header-text title
                           :asset-id    asset-id}))}]])]]))
